import { get } from 'lodash'

import { getPathString } from '@helpers'
import { ObjectDataRecord } from '@types'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

export const getDynamicColumnFieldKey = (item: ObjectDataRecord, key: EmbeddedObject[]): string => {
  return get(item, getPathString(key))
}
